<template>
  <div class="input-field">
    <input v-model="isChecked" :id="id" :checked="checked" :value="value" type="checkbox" @input="handleInput">
  </div>
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      isChecked: false
    }
  },
  methods: {
    handleInput() {
      this.isChecked = !this.isChecked;
      this.$emit('update:modelValue', this.isChecked);
      this.$emit('onChecked', {
        value: this.$props.value,
        checked: this.isChecked
      });
    },
    setChecked(checked) {
      this.isChecked = checked;
    }
  },
  mounted() {
    this.isChecked = this.$props.checked;
  }
}
</script>

<style lang="scss" scoped>
//
//label {
//  padding: 0 5px 0 5px;
//}
//
//input[type='checkbox'] {
//  -webkit-appearance : none;
//  appearance         : none;
//  width: 18px;
//  height: 18px;
//  border: 2px solid #ccc;
//  border-radius: 4px;
//  outline: none;
//
//}
//input[type='checkbox']:checked {
//
//  border: 2px solid $color-dark-brown;
//
//}
//
//input[type='checkbox']:not(:checked):hover:before {
//  box-shadow: 0px 0px 0px 11px $color-dark-brown;
//  border-radius: 50%;
//  opacity: 1;
//}
//input[type='checkbox']:checked:hover:before {
//  box-shadow: 0px 0px 0px 11px $color-dark-brown;
//  border-radius: 50%;
//  opacity: 1;
//
//}
//
//input[type='checkbox']:before {
//  content: '';
//  display: block;
//  width: 100%;
//  height: 100%;
//  margin: 0% auto;
//  transition: 0.3s;
//}
//
//input[type='checkbox']:checked:before {
//  background: $color-dark-brown;
//  //background-image: url("~@/assets/images/checkbox-arrrow.webp");
//  background-position: center;
//  background-repeat: no-repeat;
//
//
//}
</style>